import { Grid, Stack, Typography, FormControlLabel, Checkbox, Button, FormGroup } from "@mui/material";

interface PrivatePolicyEmailSettingsProps {
  uploadSuccessEmailEnabled: boolean;
  setUploadSuccessEmailEnabled: (enabled: boolean) => void;
  attachSuccessOrRejectionEmailsEnabled: boolean;
  setattachSuccessOrRejectionEmailsEnabled: (enabled: boolean) => void;
  policyExpirationRemindersEnabled: boolean;
  setPolicyExpirationRemindersEnabled: (enabled: boolean) => void;
}

export function PrivatePolicyEmailSettings({
  uploadSuccessEmailEnabled,
  setUploadSuccessEmailEnabled,
  attachSuccessOrRejectionEmailsEnabled,
  setattachSuccessOrRejectionEmailsEnabled,
  policyExpirationRemindersEnabled,
  setPolicyExpirationRemindersEnabled,
}: PrivatePolicyEmailSettingsProps) {
  const handleClearAll = () => {
    setUploadSuccessEmailEnabled(false);
    setattachSuccessOrRejectionEmailsEnabled(false);
    setPolicyExpirationRemindersEnabled(false);
  };

  const handleSelectAll = () => {
    setUploadSuccessEmailEnabled(true);
    setattachSuccessOrRejectionEmailsEnabled(true);
    setPolicyExpirationRemindersEnabled(true);
  };

  return (
    <Grid item container xs={12} mt={1}>
      <Grid item container xs={12} sx={{ position: "relative" }}>
        <Typography variant="subtitle1" gutterBottom>
          Email Settings
        </Typography>
        <Stack direction="row" spacing={1} sx={{ position: "absolute", top: 0, right: 0 }}>
          <Button
            size="small"
            variant="text"
            color="primary"
            sx={{
              minWidth: "auto",
              p: 0,
              textTransform: "none",
            }}
            onClick={handleSelectAll}
          >
            Select all
          </Button>
          <Button
            size="small"
            variant="text"
            color="primary"
            sx={{
              minWidth: "auto",
              p: 0,
              textTransform: "none",
            }}
            onClick={handleClearAll}
          >
            Clear all
          </Button>
        </Stack>
      </Grid>
      <Grid item container xs={12}>
        <FormGroup>
          <FormControlLabel
            label="Remind tenant 30 days before expiry"
            control={
              <Checkbox
                checked={policyExpirationRemindersEnabled}
                onChange={(e) => setPolicyExpirationRemindersEnabled(e.target.checked)}
              />
            }
          />
          <FormControlLabel
            label="Send upload success email"
            control={<Checkbox checked={uploadSuccessEmailEnabled} onChange={(e) => setUploadSuccessEmailEnabled(e.target.checked)} />}
          />
          <FormControlLabel
            label="Send attach success/rejection emails"
            control={
              <Checkbox
                checked={attachSuccessOrRejectionEmailsEnabled}
                onChange={(e) => setattachSuccessOrRejectionEmailsEnabled(e.target.checked)}
              />
            }
          />
        </FormGroup>
      </Grid>
    </Grid>
  );
}
